interface Props {
  className?: string
}
export function FormTextarea(props: Props & Record<string, unknown>) {
  const { className = '', ...rest } = props

  return (
    <textarea
      {...rest}
      className={`w-full p-[1em] min-h-[12em] text-3xl leading-[1.5] font-bold bg-white/10 ${className}`}
    />
  )
}
